import React, { useEffect, useState } from "react";

import AOS from "aos";
import "aos/dist/aos.css";
import "../../css/Mirissa.css";

import { storage } from "../../firebase";
import { ref, getDownloadURL } from "firebase/storage";

function Gems() {

    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
    }, []);

    const [img1, setImg1] = useState("");
    const [img2, setImg2] = useState("");

    const [g3, setG3] = useState("");
    const [g4, setG4] = useState("");

    const [g6, setG6] = useState("");
    const [g7, setG7] = useState("");

    const [act1, setAct1] = useState("");
    const [act2, setAct2] = useState("");
    const [act3, setAct3] = useState("");
    const [act4, setAct4] = useState("");
    const [act5, setAct5] = useState("");
    const [act6, setAct6] = useState("");
    const [act7, setAct7] = useState("");
    const [act8, setAct8] = useState("");
    const [act9, setAct9] = useState("");

    const [imgHero, setImgHero] = useState("");

    useEffect(() => {
        getDownloadURL(ref(storage, "Gem Mining.jpg")).then(setImg1);
        getDownloadURL(ref(storage, "Blue Sapphire.jpg")).then(setImg2);

        getDownloadURL(ref(storage, "Gemstone Collection.jpg")).then(setG3);
        getDownloadURL(ref(storage, "Gem Cutting and Polishing.jpg")).then(setG4);

        getDownloadURL(ref(storage, "Gemstone Gallery Image 1.jpg")).then(setG6);
        getDownloadURL(ref(storage, "Gemstone Gallery Image 2.jpg")).then(setG7);

        // Activity icons
        getDownloadURL(ref(storage, "Ratnapura Gem Mines.jpg")).then(setAct1);
        getDownloadURL(ref(storage, "Traditional Soil Washing for Gems.jpg")).then(setAct2);
        getDownloadURL(ref(storage, "Gem Mining Tools in Sri Lanka.jpg")).then(setAct3);

        getDownloadURL(ref(storage, "Gem Cutting Studio in Sri Lanka.jpg")).then(setAct4);
        getDownloadURL(ref(storage, "Gem Polishing Techniques.jpg")).then(setAct5);
        getDownloadURL(ref(storage, "Fine Jewellery Showroom.jpg")).then(setAct6);

        getDownloadURL(ref(storage, "Gem Museum.jpg")).then(setAct7);
        getDownloadURL(ref(storage, "Gem Market and Trading.jpg")).then(setAct8);
        getDownloadURL(ref(storage, "Gem Testing Laboratory.jpg")).then(setAct9);

        getDownloadURL(ref(storage, "Gems-hero.jpg")).then(setImgHero);
    }, []);

    return (
        <div className="destination-container">
            {/* HERO SECTION */}
            <section
                className="mirissa-hero"
                style={{ backgroundImage: `url(${imgHero})` }}
                data-aos="fade-down"
            >
                <div className="overlay">
                    <h1>Gems of Sri Lanka</h1>
                </div>
            </section>

            {/* MAIN CONTENT */}
            <section className="mirissa-container">

                {/* LEFT CONTENT */}
                <div className="mirissa-left" data-aos="fade-right">

                    <h2>Gems of Sri Lanka</h2>

                    <p>
                        Sri Lanka, often called the “Gem Island”, is one of the world’s finest sources of rare and precious gemstones.
                        For over 2,500 years, the island has dazzled traders, explorers, and royals with its vibrant sapphires, rubies,
                        moonstones and an array of semi-precious stones found in its rich mineral soils.
                    </p>

                    <p>
                        Our exclusive Gems of Sri Lanka experience takes you deep into the heart of Sri Lanka’s gem culture—exploring
                        mines, workshops, gem museums and authentic gem trading centres. Guided by experts with years of industry
                        knowledge, you’ll witness how these treasures are mined, cut, polished, and transformed into world-class jewels.
                        Whether you're a gem lover, collector, or simply curious, this tour opens the door to a glittering world
                        filled with colour, craftsmanship and heritage.
                    </p>

                    <div className="mirissa-top-gallery">
                        <img src={img1} alt="Gem Mining" />
                        <img src={img2} alt="Blue Sapphire" />
                    </div>

                    <p>
                        Sri Lanka is globally renowned for producing some of the rarest and most valuable gems—especially Ceylon Blue
                        Sapphires. Cities like Ratnapura, known as the “City of Gems”, have been supplying precious stones to the world
                        for centuries. The island’s gem industry continues to thrive, powered by traditional mining methods and expert
                        craftsmanship passed down through generations.
                    </p>

                    <div className="mirissa-top-gallery">
                        <img src={g3} alt="Gemstone Collection" />
                        <img src={g4} alt="Gem Cutting and Polishing" />

                    </div>

                    <p>
                        From the depths of gem mines to the brilliance of cutting studios, Sri Lanka offers a complete journey through
                        its gemstone heritage. You’ll get the opportunity to learn about natural gem formation, modern gem testing
                        technology, gemstone certification, and experience the authentic gem-trading culture that thrives across the island.
                    </p>

                    <h3>Ceylon Blue Sapphire</h3>

                    <p>
                        Sri Lanka’s most prized gemstone. Admired for its vivid cornflower-blue colour, clarity and brilliance,
                        the Ceylon Sapphire has adorned kings, queens, and celebrities for centuries.
                    </p>

                    <h3>Star Sapphire</h3>

                    <p>
                        A rare stone displaying a mystical six-ray star effect known as “asterism”. Sri Lanka produces some of the
                        finest Star Sapphires in the world.
                    </p>

                    <h3>Moonstone</h3>

                    <p>
                        Famous for its soft glow and milky sheen, Sri Lankan moonstones are cherished for their calming, spiritual
                        appearance. The blue moonstones of Meetiyagoda are especially unique.
                    </p>

                    <h3>Ruby & Pink Sapphire</h3>

                    <p>
                        Sri Lanka’s rubies and pink sapphires are celebrated for their rich colour tones. These gems are exceptionally
                        popular for fine jewellery and investment-grade collections.
                    </p>

                    <h3>Alexandrite & Chrysoberyl</h3>

                    <p>
                        Known for their colour-changing effect, these stones are rare, valuable, and admired by gem collectors worldwide.
                    </p>

                    <p>
                        Sri Lanka is one of the few places on Earth where such a wide variety of gemstones are naturally found within
                        a small geographical area. This diversity, paired with expert craftsmanship, makes Sri Lanka a global hub
                        for gemstone lovers.
                    </p>

                    <p>
                        Include the Gems of Sri Lanka experience in your itinerary and explore a radiant world of history, luxury,
                        and natural beauty—an unforgettable journey into the island’s sparkling treasures.
                    </p>

                    {/* ACTIVITIES SECTION */}
                    <div className="mirissa-activities" data-aos="fade-up">

                        <details className="activity-box" open>
                            <summary>• Gem Mining Experience</summary>

                            <p>
                                Discover the traditional gem-mining process used for centuries in Sri Lanka. Visit gem pits in Ratnapura,
                                meet miners, learn about soil washing, and witness how raw stones are unearthed. This authentic experience
                                gives you a rare insight into the origins of the island’s precious gems.
                            </p>

                            <div className="activity-gallery">
                                <div className="activity-card">
                                    <img src={act1} alt="Ratnapura Gem Mines" />
                                    <p>Ratnapura Gem Mines</p>
                                </div>

                                <div className="activity-card">
                                    <img src={act2} alt="Traditional Soil Washing for Gems" />
                                    <p>Traditional Soil Washing for Gems</p>
                                </div>

                                <div className="activity-card">
                                    <img src={act3} alt="Gem Mining Tools" />
                                    <p>Mining Tools</p>
                                </div>
                            </div>
                        </details>

                        <details className="activity-box">
                            <summary>• Cutting, Polishing & Craftsmanship</summary>

                            <p>
                                Visit gem-cutting studios where talented artisans transform raw stones into perfectly polished jewels.
                                Learn about different cuts, polishing techniques, gemstone grading, and the importance of precision
                                in bringing out a gem’s true brilliance.
                            </p>

                            <div className="activity-gallery">
                                <div className="activity-card">
                                    <img src={act4} alt="Gem Cutting Studio" />
                                    <p>Gem Cutting Studio</p>
                                </div>

                                <div className="activity-card">
                                    <img src={act5} alt="Gem Polishing Techniques" />
                                    <p>Gem Polishing Techniques</p>
                                </div>

                                <div className="activity-card">
                                    <img src={act6} alt="Fine Jewellery Showroom" />
                                    <p>Fine Jewellery Showroom</p>
                                </div>
                            </div>
                        </details>

                        <details className="activity-box">
                            <summary>• Gem Museums & Trading Experience</summary>

                            <p>
                                Explore gem museums that showcase rare Sri Lankan gemstones, historical artefacts, and educational
                                displays on gem formation. Then step into gem trading centres where local experts help you understand
                                gemstone value, certification, and how to identify genuine stones.
                            </p>

                            <div className="activity-gallery">
                                <div className="activity-card">
                                    <img src={act7} alt="Gem Museum" />
                                    <p>Gem Museums</p>
                                </div>

                                <div className="activity-card">
                                    <img src={act8} alt="Gem Market and Trading" />
                                    <p>Gem Market and Trading</p>
                                </div>

                                <div className="activity-card">
                                    <img src={act9} alt="Gem Testing Laboratory" />
                                    <p>Gem Testing Laboratory</p>
                                </div>
                            </div>

                        </details>

                    </div>

                    {/* GALLERY SECTION */}
                    <div className="mirissa-parrot-rock" data-aos="fade-up">

                        <div className="parrot-gallery">
                            <img src={g6} alt="Gemstone Gallery Image 1" />
                            <img src={g7} alt="Gemstone Gallery Image 2" />
                        </div>

                    </div>

                </div>

                {/* RIGHT INQUIRY FORM */}
                <div className="mirissa-form" data-aos="fade-left">
                    <h3>Make an Inquiry</h3>

                    <form
                        onSubmit={(e) => {
                            e.preventDefault();

                            const name = e.target.name.value;
                            const email = e.target.email.value;
                            const country = e.target.country.value;
                            const code = e.target.code.value;
                            const phone = e.target.phone.value;
                            const arrival = e.target.arrival.value;
                            const departure = e.target.departure.value;
                            const interest = e.target.interest.value;
                            const vehicle = e.target.vehicle.value;   // ✅ NEW
                            const adults = e.target.adults.value;
                            const kids = e.target.kids.value;
                            const message = e.target.message.value;

                            const fullMessage = `
                📌 NEW TOUR BOOKING

                👤 Name: ${name}
                📧 Email: ${email}
                🌍 Country: ${country}
                📞 Phone: ${code} ${phone}
                📅 Arrival: ${arrival}
                📅 Departure: ${departure}
                🎯 Interest: ${interest}
                🚗 Vehicle Preference: ${vehicle}
                👨‍👩‍👧 Adults: ${adults}
                🧒 Kids: ${kids}

                💬 Message: ${message} 
              `;

                            // ✅ SEND WHATSAPP
                            const whatsappNumber = "94710440430"; // your WhatsApp number
                            const whatsappURL =
                                "https://wa.me/" + whatsappNumber + "?text=" + encodeURIComponent(fullMessage);

                            window.open(whatsappURL, "_blank");

                            // ✅ SEND EMAIL
                            const mailto =
                                "mailto:ceylongracetravels@gmail.com" +
                                "?subject=" + encodeURIComponent("New Tour Booking") +
                                "&body=" + encodeURIComponent(fullMessage);

                            window.location.href = mailto;

                            alert("✅ Your Booking is Send!");
                        }}
                    >
                        <input name="name" type="text" placeholder="Name *" />
                        <input name="email" type="email" placeholder="Email Address *" />

                        <select name="country" required>
                            <option value="">Choose Your Country *</option>
                            <option value="Afghanistan">Afghanistan</option>
                            <option value="Albania">Albania</option>
                            <option value="Algeria">Algeria</option>
                            <option value="Andorra">Andorra</option>
                            <option value="Angola">Angola</option>
                            <option value="Antigua and Barbuda">Antigua and Barbuda</option>
                            <option value="Argentina">Argentina</option>
                            <option value="Armenia">Armenia</option>
                            <option value="Australia">Australia</option>
                            <option value="Austria">Austria</option>
                            <option value="Azerbaijan">Azerbaijan</option>
                            <option value="Bahamas">Bahamas</option>
                            <option value="Bahrain">Bahrain</option>
                            <option value="Bangladesh">Bangladesh</option>
                            <option value="Barbados">Barbados</option>
                            <option value="Belarus">Belarus</option>
                            <option value="Belgium">Belgium</option>
                            <option value="Belize">Belize</option>
                            <option value="Benin">Benin</option>
                            <option value="Bhutan">Bhutan</option>
                            <option value="Bolivia">Bolivia</option>
                            <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
                            <option value="Botswana">Botswana</option>
                            <option value="Brazil">Brazil</option>
                            <option value="Brunei">Brunei</option>
                            <option value="Bulgaria">Bulgaria</option>
                            <option value="Burkina Faso">Burkina Faso</option>
                            <option value="Burundi">Burundi</option>
                            <option value="Cabo Verde">Cabo Verde</option>
                            <option value="Cambodia">Cambodia</option>
                            <option value="Cameroon">Cameroon</option>
                            <option value="Canada">Canada</option>
                            <option value="Central African Republic">Central African Republic</option>
                            <option value="Chad">Chad</option>
                            <option value="Chile">Chile</option>
                            <option value="China">China</option>
                            <option value="Colombia">Colombia</option>
                            <option value="Comoros">Comoros</option>
                            <option value="Congo, Democratic Republic of the">Congo, Democratic Republic of the</option>
                            <option value="Congo, Republic of the">Congo, Republic of the</option>
                            <option value="Costa Rica">Costa Rica</option>
                            <option value="Côte d’Ivoire">Côte d’Ivoire</option>
                            <option value="Croatia">Croatia</option>
                            <option value="Cuba">Cuba</option>
                            <option value="Cyprus">Cyprus</option>
                            <option value="Czech Republic">Czech Republic</option>
                            <option value="Denmark">Denmark</option>
                            <option value="Djibouti">Djibouti</option>
                            <option value="Dominica">Dominica</option>
                            <option value="Dominican Republic">Dominican Republic</option>
                            <option value="Ecuador">Ecuador</option>
                            <option value="Egypt">Egypt</option>
                            <option value="El Salvador">El Salvador</option>
                            <option value="Equatorial Guinea">Equatorial Guinea</option>
                            <option value="Eritrea">Eritrea</option>
                            <option value="Estonia">Estonia</option>
                            <option value="Eswatini">Eswatini</option>
                            <option value="Ethiopia">Ethiopia</option>
                            <option value="Fiji">Fiji</option>
                            <option value="Finland">Finland</option>
                            <option value="France">France</option>
                            <option value="Gabon">Gabon</option>
                            <option value="Gambia">Gambia</option>
                            <option value="Georgia">Georgia</option>
                            <option value="Germany">Germany</option>
                            <option value="Ghana">Ghana</option>
                            <option value="Greece">Greece</option>
                            <option value="Grenada">Grenada</option>
                            <option value="Guatemala">Guatemala</option>
                            <option value="Guinea">Guinea</option>
                            <option value="Guinea-Bissau">Guinea-Bissau</option>
                            <option value="Guyana">Guyana</option>
                            <option value="Haiti">Haiti</option>
                            <option value="Honduras">Honduras</option>
                            <option value="Hungary">Hungary</option>
                            <option value="Iceland">Iceland</option>
                            <option value="India">India</option>
                            <option value="Indonesia">Indonesia</option>
                            <option value="Iran">Iran</option>
                            <option value="Iraq">Iraq</option>
                            <option value="Ireland">Ireland</option>
                            <option value="Israel">Israel</option>
                            <option value="Italy">Italy</option>
                            <option value="Jamaica">Jamaica</option>
                            <option value="Japan">Japan</option>
                            <option value="Jordan">Jordan</option>
                            <option value="Kazakhstan">Kazakhstan</option>
                            <option value="Kenya">Kenya</option>
                            <option value="Kiribati">Kiribati</option>
                            <option value="Korea, North">Korea, North</option>
                            <option value="Korea, South">Korea, South</option>
                            <option value="Kuwait">Kuwait</option>
                            <option value="Kyrgyzstan">Kyrgyzstan</option>
                            <option value="Laos">Laos</option>
                            <option value="Latvia">Latvia</option>
                            <option value="Lebanon">Lebanon</option>
                            <option value="Lesotho">Lesotho</option>
                            <option value="Liberia">Liberia</option>
                            <option value="Libya">Libya</option>
                            <option value="Liechtenstein">Liechtenstein</option>
                            <option value="Lithuania">Lithuania</option>
                            <option value="Luxembourg">Luxembourg</option>
                            <option value="Madagascar">Madagascar</option>
                            <option value="Malawi">Malawi</option>
                            <option value="Malaysia">Malaysia</option>
                            <option value="Maldives">Maldives</option>
                            <option value="Mali">Mali</option>
                            <option value="Malta">Malta</option>
                            <option value="Marshall Islands">Marshall Islands</option>
                            <option value="Mauritania">Mauritania</option>
                            <option value="Mauritius">Mauritius</option>
                            <option value="Mexico">Mexico</option>
                            <option value="Micronesia">Micronesia</option>
                            <option value="Moldova">Moldova</option>
                            <option value="Monaco">Monaco</option>
                            <option value="Mongolia">Mongolia</option>
                            <option value="Montenegro">Montenegro</option>
                            <option value="Morocco">Morocco</option>
                            <option value="Mozambique">Mozambique</option>
                            <option value="Myanmar (Burma)">Myanmar (Burma)</option>
                            <option value="Namibia">Namibia</option>
                            <option value="Nauru">Nauru</option>
                            <option value="Nepal">Nepal</option>
                            <option value="Netherlands">Netherlands</option>
                            <option value="New Zealand">New Zealand</option>
                            <option value="Nicaragua">Nicaragua</option>
                            <option value="Niger">Niger</option>
                            <option value="Nigeria">Nigeria</option>
                            <option value="North Macedonia">North Macedonia</option>
                            <option value="Norway">Norway</option>
                            <option value="Oman">Oman</option>
                            <option value="Pakistan">Pakistan</option>
                            <option value="Palau">Palau</option>
                            <option value="Panama">Panama</option>
                            <option value="Papua New Guinea">Papua New Guinea</option>
                            <option value="Paraguay">Paraguay</option>
                            <option value="Peru">Peru</option>
                            <option value="Philippines">Philippines</option>
                            <option value="Poland">Poland</option>
                            <option value="Portugal">Portugal</option>
                            <option value="Qatar">Qatar</option>
                            <option value="Romania">Romania</option>
                            <option value="Russia">Russia</option>
                            <option value="Rwanda">Rwanda</option>
                            <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
                            <option value="Saint Lucia">Saint Lucia</option>
                            <option value="Saint Vincent and the Grenadines">Saint Vincent and the Grenadines</option>
                            <option value="Samoa">Samoa</option>
                            <option value="San Marino">San Marino</option>
                            <option value="Sao Tome and Principe">Sao Tome and Principe</option>
                            <option value="Saudi Arabia">Saudi Arabia</option>
                            <option value="Senegal">Senegal</option>
                            <option value="Serbia">Serbia</option>
                            <option value="Seychelles">Seychelles</option>
                            <option value="Sierra Leone">Sierra Leone</option>
                            <option value="Singapore">Singapore</option>
                            <option value="Slovakia">Slovakia</option>
                            <option value="Slovenia">Slovenia</option>
                            <option value="Solomon Islands">Solomon Islands</option>
                            <option value="Somalia">Somalia</option>
                            <option value="South Africa">South Africa</option>
                            <option value="South Sudan">South Sudan</option>
                            <option value="Spain">Spain</option>
                            <option value="Sri Lanka">Sri Lanka</option>
                            <option value="Sudan">Sudan</option>
                            <option value="Suriname">Suriname</option>
                            <option value="Sweden">Sweden</option>
                            <option value="Switzerland">Switzerland</option>
                            <option value="Syria">Syria</option>
                            <option value="Taiwan">Taiwan</option>
                            <option value="Tajikistan">Tajikistan</option>
                            <option value="Tanzania">Tanzania</option>
                            <option value="Thailand">Thailand</option>
                            <option value="Timor-Leste">Timor-Leste</option>
                            <option value="Togo">Togo</option>
                            <option value="Tonga">Tonga</option>
                            <option value="Trinidad and Tobago">Trinidad and Tobago</option>
                            <option value="Tunisia">Tunisia</option>
                            <option value="Turkey">Turkey</option>
                            <option value="Turkmenistan">Turkmenistan</option>
                            <option value="Tuvalu">Tuvalu</option>
                            <option value="Uganda">Uganda</option>
                            <option value="Ukraine">Ukraine</option>
                            <option value="United Arab Emirates">United Arab Emirates</option>
                            <option value="United Kingdom">United Kingdom</option>
                            <option value="United States">United States</option>
                            <option value="Uruguay">Uruguay</option>
                            <option value="Uzbekistan">Uzbekistan</option>
                            <option value="Vanuatu">Vanuatu</option>
                            <option value="Vatican City">Vatican City</option>
                            <option value="Venezuela">Venezuela</option>
                            <option value="Vietnam">Vietnam</option>
                            <option value="Yemen">Yemen</option>
                            <option value="Zambia">Zambia</option>
                            <option value="Zimbabwe">Zimbabwe</option>
                        </select>

                        <div className="phone-row">
                            <input name="code" className="code" type="text" placeholder="Code" />
                            <input name="phone" className="phone" type="text" placeholder="Phone Number *" />
                        </div>

                        <label htmlFor="arrival">Arrival Date</label>
                        <input name="arrival" type="date" />

                        <label htmlFor="departure">Departure Date</label>
                        <input name="departure" type="date" />

                        <select name="interest">
                            <option value="">Choose Your Interest *</option>
                            <option value="Eco">Eco</option>
                            <option value="Beach">Beach</option>
                            <option value="Cultural">Cultural</option>
                            <option value="Adventure">Adventure</option>
                            <option value="Wild Life">Wild Life</option>
                            <option value="Relax and Wellness">Relax and Wellness</option>
                            <option value="Honeymoon">Honeymoon</option>
                            <option value="Ramayana Trail">Ramayana Trail</option>
                            <option value="All in one Trails">All in one Trails</option>
                        </select>

                        <select name="vehicle">
                            <option value="">Select Vehicle Type *</option>
                            <option value="Sedan – Toyota Prius (3 Pax)">Sedan – Toyota Prius (3 Pax)</option>
                            <option value="Sedan – Toyota Axio (3 Pax)">Sedan – Toyota Axio (3 Pax)</option>
                            <option value="Sedan – Honda Grace (3 Pax)">Sedan – Honda Grace (3 Pax)</option>
                            <option value="Mini – Suzuki Wagon R (2 Pax)">Mini – Suzuki Wagon R (2 Pax)</option>
                            <option value="Mini – Toyota Aqua (2 Pax)">Mini – Toyota Aqua (2 Pax)</option>
                            <option value="Van – Suzuki Every (4 Pax)">Van – Suzuki Every (4 Pax)</option>
                            <option value="Van – Mini Van (4 Pax)">Van – Mini Van (4 Pax)</option>
                            <option value="Van – Toyota Noha (4 Pax)">Van – Toyota Noha (4 Pax)</option>
                            <option value="Bus – Mitsubishi Rosa (12 Pax)">Bus – Mitsubishi Rosa (12 Pax)</option>
                            <option value="Bus – King Long (12 Pax)">Bus – King Long (12 Pax)</option>
                        </select>

                        <input name="adults" type="number" placeholder="Adults *" />
                        <input name="kids" type="number" placeholder="Kids" />

                        <textarea name="message" placeholder="Enter your message"></textarea>

                        <button type="submit">SUBMIT</button>
                    </form>

                </div>

            </section>

            {/* CTA Section */}
            <section className="cta-section" data-aos="fade-up">
                <div className="cta-box">
                    <div className="cta-left">
                        <img src={require("../../assets/hile.png")} className="cta-icon" alt="icon" />
                        <div className="cta-text">
                            <h2>Ready To Adventure And Enjoy Natural</h2>
                            <p>Reach Ceylon Authentic Tours & Travels For A Secure, Luxurious, And Unforgettable Adventure!</p>
                        </div>
                    </div>

                    <img src={require("../../assets/plan.png")} className="cta-plane" alt="plane" />

                    <button className="cta-btn">LET’S GET STARTED</button>
                </div>
            </section>
        </div>
    );
}

export default Gems;
